var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-atn"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atn",
    clipPath: "url(#clip-atn)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "support-svgrepo-com",
    transform: "translate(-5.734 -8.093)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "view-box",
    width: 113,
    height: 113,
    transform: "translate(-0.266 0.093)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M37.347,82.869a12.834,12.834,0,0,1,23.935-6.452c9.757-4.3,13.412-11.06,13.412-23.9V38.515C74.695,19.878,64.186,7,47.851,7S21.008,19.883,21.008,38.515v16.34a3.506,3.506,0,0,1-3.5,3.5H12.838A12.852,12.852,0,0,1,0,45.522V40.853A12.857,12.857,0,0,1,12.838,28.011H15.07C18.6,11.34,30.7,0,47.851,0S77.094,11.34,80.628,28.011H82.86A12.857,12.857,0,0,1,95.7,40.849v4.668A12.852,12.852,0,0,1,82.86,58.355H81.417A27.31,27.31,0,0,1,63.024,83.285a12.84,12.84,0,0,1-25.676-.415Zm7,0a5.836,5.836,0,1,0,5.836-5.836,5.836,5.836,0,0,0-5.836,5.836ZM81.7,51.357H82.86a5.84,5.84,0,0,0,5.84-5.836V40.853a5.84,5.84,0,0,0-5.836-5.84H81.7ZM7,40.853v4.668a5.84,5.84,0,0,0,5.836,5.831h1.167V35.013H12.838A5.84,5.84,0,0,0,7,40.853Z",
    transform: "translate(8.17 10.438)",
    fill: "#6c637b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtn);
export default __webpack_public_path__ + "static/media/atn.410f487eb2d2c877e05e709c33311ae1.svg";
export { ForwardRef as ReactComponent };